import PageContainer, {Props as PageContainerProps} from "@/components/PageContainer";
import { SxProps } from "@mui/material";
import { FC } from "react";

interface Props extends PageContainerProps {
  sx?: SxProps
}

const AuthLayout:FC<Props> = ({...props}) => {
  return (
    <PageContainer 
      maxWidth="xs"
      titleProps={{variant: 'h1', textAlign: 'center'}}
      descriptionProps={{textAlign: 'center'}}
      {...props}

      sx={{
        display: 'flex', 
        flexDirection:"column", 
        justifyContent: 'center', 
        height:"100%", 
        ...props.sx
      }}
    />
  )
}

export default AuthLayout;